<ng-container [formGroup]="form" *transloco="let t; prefix: 'loan-eligibility.financialInfo'">
    <ng-container formGroupName="financialInfo">
        <div class="flex flex-col gap-8 max-w-[800px] mx-auto">
            <div class="mb-10 text-center">
                <h3 class="text-black rfs:text-3xl mb-5">{{t('title')}}</h3>
                <p class="text-gray-900">{{t('description')}}</p>
            </div>
            <div class="grid grid-cols-1 sm:grid-cols-2 gap-x-8 gap-y-12">
                <fieldset class="flex flex-col gap-2 group/input">
                    <label
                        class="font-semibold flex items-center gap-4 text-black group-disabled:text-gray-300">
                        <div class="text-gray-950 font-semibold">{{t('yearly-income')}}<span class="text-error">*</span></div>
                        <i class="icon-info-circle text-gray-700 text-base" customTooltip [tooltipTemplate]="yearlyIncomeTooltip"></i>
                    </label>

                    <ng-template #yearlyIncomeTooltip>
                        {{t('yearly-income-tooltip')}}
                    </ng-template>
                    <div
                        class="border border-gray-300 rounded-full overflow-hidden flex flex-row gap-2 items-center py-3 px-4 group-focus-within/input:text-gray-900 group-focus-within/input:border-primary-500 transition-colors duration-300 outline-none bg-white">
                        <span class="text-gray-900 font-semibold">€</span>
                        <input [formControlName]="'householdIncomePerYear'" mask="separator.2"
                            [thousandSeparator]="thousandSeparator"
                            class="text-gray-500 bg-transparent outline-none flex-1">
                    </div>
                    <!-- <div class="flex flex-row items-center gap-6 text-gray-500 text-sm">
                        {{t('helpHowConfortablePay')}}
                    </div> -->
                </fieldset>
                <fieldset class="flex flex-col gap-2 group/input">
                    <label
                        class="font-semibold flex items-center gap-4 text-black group-disabled:text-gray-300">
                        <div class="text-gray-950 font-semibold">{{t('yearly-obligations')}}<span class="text-error">*</span></div>
                        <i class="icon-info-circle text-gray-700 text-base" customTooltip [tooltipTemplate]="yearlyObligationsTooltip"></i>
                    </label>

                    <ng-template #yearlyObligationsTooltip>
                        {{t('yearly-obligations-tooltip')}}
                    </ng-template>
                    <div
                        class="border border-gray-300 rounded-full overflow-hidden flex flex-row gap-2 items-center py-3 px-4 group-focus-within/input:text-gray-900 group-focus-within/input:border-primary-500 transition-colors duration-300 outline-none bg-white">
                        <span class="text-gray-900 font-semibold">€</span>
                        <input [formControlName]="'householdDebt'" mask="separator.2"
                            [thousandSeparator]="thousandSeparator"
                            class="text-gray-500 bg-transparent outline-none flex-1">
                    </div>
                    <div class="text-900">{{t('other-payments')}}</div>
                    <!-- <div class="flex flex-row items-center gap-6 text-gray-500 text-sm">
                        {{t('soWeKnowOtherDebts')}}
                    </div> -->
                </fieldset>
                <fieldset class="flex flex-col gap-2 group/input">
                    <label
                        class="font-semibold flex items-center gap-4 text-black group-disabled:text-gray-300">
                        <div class="text-gray-950 font-semibold">{{t('tax-per-year')}}<span class="text-error">*</span></div>
                        <i class="icon-info-circle text-gray-700 text-base" customTooltip [tooltipTemplate]="taxPerYearTooltip"></i>
                    </label>

                    <ng-template #taxPerYearTooltip>
                        {{t('tax-per-year-tooltip')}}
                    </ng-template>

                    <!-- <div class="flex flex-row items-center gap-1 text-gray-500 text-sm">
                        {{t('calculateTaxAt')}}<a href="https://aftertax.gr/" target="_blank"
                            class="text-secondary underline">AfterTax.gr</a>
                    </div> -->
                    <div
                        class="border border-gray-300 rounded-full overflow-hidden flex flex-row gap-2 items-center py-3 px-4 group-focus-within/input:text-gray-900 group-focus-within/input:border-primary-500 transition-colors duration-300 outline-none bg-white">
                        <span class="text-gray-900 font-semibold">€</span>
                        <input [formControlName]="'taxPerYear'" mask="separator.2"
                            [thousandSeparator]="thousandSeparator"
                            class="text-gray-500 bg-transparent outline-none flex-1">
                    </div>
                </fieldset>
            </div>
        </div>
    </ng-container>
</ng-container>
